<script setup lang="ts">
import { RouterView } from 'vue-router'
import '@/assets/main.scss'
import Toast from 'primevue/toast'
import MainLayout from '@/onenetwork/layouts/MainLayout.vue'
import { getToken, messaging, onMessage } from '@/firebase.ts'
import { useSiteContextStore } from '@/onenetwork/stores/onenetwork.store.context.ts'
import { computed, ref } from 'vue'
import { useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth.ts'
import { useOneNetworkNotificationStore } from '@/onenetwork/stores/onenetwork.store.notification.ts'
import { Icon } from '@iconify/vue'

const siteContextStore = useSiteContextStore()
const authStore = useAuthStore()
const siteNotificationStore = useOneNetworkNotificationStore()
const appEnv = __APP_ENV__
const fcmToken = ref(localStorage.getItem('__on-fcm-token'))

if ('serviceWorker' in navigator && ["SSL", "DevSSL"].includes(appEnv)) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {

      // Lấy FCM token
      getToken(messaging, {
        vapidKey: 'BGoDC6khds2G-dz1tMbaW3GzkwDzcOXIBlt0AvQ0JeesuYCsE9LTp-i10GVCpUS1wSLXmN_rdVZ5DShQZLW6cOs',
        serviceWorkerRegistration: registration
      }).then((currentToken) => {
        if (currentToken) {

          // Gửi token lên server hoặc lưu
          if (currentToken !== fcmToken.value) {
            localStorage.setItem('__on-fcm-token', currentToken)
            fcmToken.value = currentToken
            authStore.logout()
          }
        } else {
          console.warn('No registration token available.')
        }
      }).catch((err) => {
        console.error('An error occurred while retrieving token.', err)
      })

      // Lắng nghe khi app đang mở
      onMessage(messaging, (payload) => {

        siteNotificationStore.pushNotification(payload)
      })
    })
    .catch((err) => {
      console.error('Service Worker registration failed:', err)
    })
}
navigator.serviceWorker.addEventListener('message', (event) => {
  if (event.data?.type === 'PUSH_NOTIFICATION') {
    const payload = event.data.payload;

    siteNotificationStore.pushNotification(payload)
  }
});
</script>

<template>
  <template v-if="['SSL', 'DevSSL'].includes(appEnv)">
  <MainLayout v-if="fcmToken">
    <RouterView />
  </MainLayout>
    <template v-else>
      <div class="site-loading">
        <div class="icon">
          <Icon icon="svg-spinners:blocks-shuffle-3" />
        </div>
        <div class="text">
          OneNetwork
        </div>
      </div>
    </template>
  </template>
  <template v-else>
    <MainLayout>
      <RouterView />
    </MainLayout>
  </template>

  <Toast position="bottom-right"></Toast>
  <ConfirmDialog></ConfirmDialog>
</template>

<style scoped></style>
